// removed by extract-text-webpack-plugin
module.exports = {"markdown":"markdown--54cd0"};